import { Injectable } from "@angular/core";
import { Adapter } from "src/app/adapter";
import * as moment from "moment";

export class GeneralLedgerDetail {
  constructor(
    public id: number,
    public companyRowId: number,
    public companyName: string,
    public documentNumber: number,
    public documentType: string,
    public jeLineNumber: number,
    public facilityRowId: number,
    public facilityName: string,
    public payItem: number,
    public parentAddressRowId: number,
    public parentName: string,
    public billToAddressRowId: number,
    public billToName: string,
    public shipToAddressRowId: number,
    public shipToName: string,
    public invoiceDate: moment.Moment,
    public glTaxDate: moment.Moment,
    public glDate: moment.Moment,
    public checkDate: moment.Moment,
    public checkClearDate: moment.Moment,
    public fiscalYear: number,
    public periodNumber: number,
    public batchRowId: number,
    public postedCode: string,
    public chartRowId: number,
    public businessUnit: string,
    public accountObject: string,
    public accountSubsidiary: string,
    public accountDescription: string,
    public subledger: string,
    public amount: number,
    public reverseVoid: string,
    public code1099: string,
    public invoiceNumber: string,
    public purchaseOrderId: number,
    public paymentTermsId: number,
    public termsDescription: string,
    public explanation: string,
    public reference: string,
    public debitAmount: number,
    public creditAmount: number,
    public changeID: string,
    public lastUpdated: moment.Moment
  ) {}
}

@Injectable({
  providedIn: "root",
})
export class GeneralLedgerDetailAdapter
  implements Adapter<GeneralLedgerDetail>
{
  adapt(item: any): GeneralLedgerDetail {
    return new GeneralLedgerDetail(
      item.GLROWID,
      item.GLCOMPANYROWID,
      item.CONAME,
      item.GLDOCUMENTNUMBER,
      item.GLDOCUMENTTYPE,
      item.GLJELINENUMBER,
      item.GLFACILITYROWID,
      item.FMFACILITYNAME,
      item.GLPAYITEM,
      item.GLPARENTADDRESSROWID,
      item.PARENTNAME,
      item.GLBILLTOADDRESSROWID,
      item.BILLTONAME,
      item.GLSHIPTOADDRESSROWID,
      item.SHIPTONAME,
      item.GLINVOICEDATE,
      item.GLTAXDATE,
      item.GLGLDATE,
      item.GLCHECKDATE,
      item.GLCHECKCLEARDATE,
      item.GLFISCALYEAR,
      item.GLPERIODNUMBER,
      item.GLBATCHROWID,
      item.GLPOSTEDCODE,
      item.GLCHARTROWID,
      item.CCBUSINESSUNIT,
      item.CAOBJ,
      item.CASUB,
      item.CADESC,
      item.GLSUBLEDGER,
      item.GLAMOUNT,
      item.GLREVERSEVOID,
      item.GL1099CODE,
      item.GLINVOICENUMBER,
      item.GLPURCHASEORDERID,
      item.GLPAYMENTTERMSROWID,
      item.PTDESCCRIPTION,
      item.GLEXPLANATION,
      item.GLREFERENCE,
      item.DEBIT,
      item.CREDIT,
      item.GLCHANGEID,
      item.GLLASTUPDATED
    );
  }
}
